import React from 'react';

export const contents = `
  <circle cx="4.5" cy="4.5" r="2.5"/>
  <circle cx="19.5" cy="19.5" r="2.5"/>
  <circle cx="19.5" cy="4.5" r="2.5"/>
  <circle cx="4.5" cy="19.5" r="2.5"/>
  <circle cx="12" cy="12" r="2.5"/>
  <path d="M7.2,10.3c-1-0.9-1.8-2-2.3-3.3"/>
  <path d="M19.1,7c-0.5,1.3-1.2,2.4-2.2,3.3"/>
  <path d="M16.9,13.7c1,0.9,1.8,2,2.2,3.3"/>
  <path d="M4.9,17c0.5-1.3,1.2-2.4,2.2-3.3"/>
`;

interface Props {
  color: string;
  size: number;
  strokeWidth: number;
  title: number;
  className?: any;
}

export const defaultProps = {
  color: 'currentColor',
  size: 24,
  strokeWidth: 2,
};

const IconMesh = (props: Partial<Props>) => {
  const { color, size, title, strokeWidth, ...otherProps } = {
    ...defaultProps,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={0}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      {...otherProps}
    >
      <title>{title}</title>
      <g dangerouslySetInnerHTML={{ __html: contents }} />
    </svg>
  );
};

export default IconMesh;
